<div class="bgColorWhite body-scroll">
  <div class="text-center boldText"><h3>{{ pageTitle }}</h3></div>

  @if (showData && !loading) {
<div class="summary-grid">
    <div>Total PTI in FC: {{ summary.totalPtiFc | number }}</div>
    <div>FX Rate: {{ summary.fxRate | number:'1.2-6' }}</div>
    <div>PTI Amount in USD: {{ summary.ptiAmtInUSD | number }}</div>
    <div>USD Basis in PTI: {{ summary.usdBasisInPTI | number }}</div>
    <div>Estimated Exchange Gain/(Loss): {{ summary.estimateExchangeGainLossInUSD | number }}</div>
  </div>
}

  @if (loading) {
<div class="formLoader"><i class="fa fa-spinner fa-spin gt-refresh"></i></div>
}

  @if (!loading && ptiTotalsData.length > 0) {
<div class="col-md-12 boldText" style="width:100%;">
    <table class="table nowrap table-bordered table-condensed table-hover table-striped boldText custom-table">
      <thead>
      <tr>
        @for (columnName of columnNames; track $index) {
<th nowrap>{{columnName}}</th>
}
      </tr>
      </thead>
      <tbody>
      @for (ptiAmtRow of ptiTotalsData; track $index) {
<tr>
        @for (columnName of columnNames; track $index) {
<td nowrap [ngClass]="(columnName.toUpperCase() !== 'PTI TYPE' && columnName.toUpperCase() !== 'YEAR') ? 'rightAlign' : ''">
          {{(columnName.toUpperCase() !== 'PTI TYPE' && columnName.toUpperCase() !== 'YEAR') ? (ptiAmtRow[columnName] | number) : ptiAmtRow[columnName]}}
        </td>
}
      </tr>
}
      </tbody>
    </table>
  </div>
}
</div>
